import { BaseType } from '../../base/base-type';

export class EmployerPlanType extends BaseType {}
